<template>
  <a class="trust-star-row" :href="hrefTo">
    <div class="star-rating">
      <div
          v-for="n in totalStars"
          :key="n"
          class="trust-star"
      >
        <!-- Volle Sterne -->
        <img
            v-if="isStarFilled(n)"
            :src="starFilled"
            alt="Gefüllter Stern"
            class="star-icon"
        />
        <!-- Teilgefüllter Stern -->
        <div
            v-else-if="isPartialStar(n)"
            class="partial-star"
            :style="getPartialStarStyle(n)"
        >
          <img :src="starFilled" />
        </div>
        <!-- Leere Sterne -->
        <img
            v-else
            :src="starEmpty"
            alt="Leerer Stern"
            class="star-icon"
        />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "star-rating",

  props: {
    rating: {
      type: Number,
      required: true, // Erwartet eine Dezimalzahl (z. B. 4.6)
    },
    totalStars: {
      type: Number,
      default: 5, // Standardmäßig 5 Sterne
    },
    hrefTo: {
      type: String,
      default: '#',
      required: false
    },
    pluginPath:
      {
        type: String,
        default: ""
      }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.loadSvgs()
    });
  },
  data() {
    return {
      starEmpty: '',
      starFilled: ''
    };
  },
  computed: {
    roundedRating() {
      return this.roundToHalfStep(this.rating);
    }
  },
  methods: {
    // Rundet die Bewertung auf den nächsten 0,5-Schritt ab
    roundToHalfStep(value) {
      return Math.floor(value * 2) / 2;
    },
    // Prüft, ob der aktuelle Stern voll gefüllt ist
    isStarFilled(n) {
      return this.roundedRating >= n;
    },
    // Prüft, ob der aktuelle Stern teilweise gefüllt ist
    isPartialStar(n) {
      const remaining = this.roundedRating - n + 1;
      return remaining > 0 && remaining < 1;
    },
    // Berechnet den Clip-Wert für Teilfüllungen
    getPartialStarStyle(n) {
      const remaining = this.roundedRating - n + 1;
      const clipValue = 100 - remaining * 100;
      return `clip-path: inset(0px ${clipValue}% 0px 0px); overflow: hidden;`;
    },
    loadSvgs () {
      this.starEmpty = `${ this.pluginPath }/images/star-empty.svg`;
      this.starFilled = `${ this.pluginPath }/images/star-filled.svg`;
    }
  },
};
</script>

